{
  "collapse": "Skjul",
  "expand": "Vis"
}
